<template>
  <div>
    <div v-if="dataPageInfos.urlPictureHeader" class="bg-header-page" :style="{ 'background-image': 'url('+ dataPageInfos.urlPictureHeader + ')' }" style="background-size:cover !important; background-position:bottom !important; bakcground-repeat:no-repeat !important; "></div>
    <div v-else class="bg-header-page" style="background-image:url('./elements/background-header-page.jpg'); background-size:cover !important; background-position:bottom !important; bakcground-repeat:no-repeat !important;"></div>
    
   
    <div v-if="dataPage.route == 'accueil'" class="accueil">
      <div class="bg-bf">
        <!-- HOME CAROUSEL -->
        <b-carousel
          id="carouselHome"
          :interval="6000"
          background="#154059"
          img-width="1024"
          img-height="480"
          fade
          no-hover-pause
        >
          <div class="d-lg-flex d-none position-absolute" id="logo">
            <img src="@/../public/elements/logo-cbgr-inverse.png" alt="logo" />
          </div>
          <div class="d-flex d-lg-none position-absolute" id="slogan">
            <h1 v-html="dataPage.title"></h1>
          </div>
          <b-carousel-slide img-blank v-if="dataPage.customizableVar[0].value">
            <div
              class="carousel-image"
              :style="{ 'background-image': 'url('+ dataPage.customizableVar[0].value + ')' }"
              style="
                background-position: top;
                background-size: cover;
              "
            ></div>
          </b-carousel-slide>
          <b-carousel-slide img-blank v-if="dataPage.customizableVar[1].value">
            <div
                class="carousel-image"
                :style="{ 'background-image': 'url('+ dataPage.customizableVar[1].value + ')' }"
                style="
                  background-position: top;
                  background-size: cover;
                "
            ></div>
          </b-carousel-slide>
          <b-carousel-slide img-blank v-if="dataPage.customizableVar[2].value">
            <div
                class="carousel-image"
                :style="{ 'background-image': 'url('+ dataPage.customizableVar[2].value + ')' }"
                style="
                  background-position: top;
                  background-size: cover;
                "
            ></div>
          </b-carousel-slide>
          <!-- MENU DESKTOP -->
          <div id="menu" class="d-none d-lg-block">
            <ul>
              <li
                class="nav-item"
                v-for="(menu, index) of $parent.dataIris.menuHeader.itemsMenu
                  .children"
                :key="index"
              >
                <router-link
                  tag="a"
                  :to="menu.route"
                  class="c-bf bg-w text-uppercase"
                  href="#"
                  >{{ menu.labelMenu }}</router-link
                >
              </li>
            </ul>
          </div>
        </b-carousel>
        <!-- CONTACT MOBILE -->
        <div class="d-block d-lg-none pt-4">
          <div class="col-12 c-w">
            <!-- GENERE CI-DESSOUS LE PAGE BUILDER EN APERCU SEUL -->
            <div
              class="item noEditMode"
              v-for="(item, index) in layout"
              :key="index"
            >
              <row-widget
                v-if="item.type == 'row'"
                :layout="layout"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
                class="mb-2"
              ></row-widget>
              <col-widget
                v-if="item.type == 'col'"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
              ></col-widget>
              <text-widget
                v-if="item.type == 'text'"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
                :themeColors="themeColors"
              ></text-widget>
              <text-area-widget
                v-if="item.type == 'content'"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
              ></text-area-widget>
              <image-widget
                v-if="item.type == 'image'"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
              ></image-widget>
              <alert-widget
                v-if="item.type == 'alert'"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
                :color="item.color"
              >
              </alert-widget>
              <button-widget
                v-if="item.type == 'button'"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
              >
              </button-widget>
              <link-widget
                v-if="item.type == 'link'"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
              >
              </link-widget>
              <title-widget
                v-if="item.type == 'title'"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
              ></title-widget>
              <quote-widget
                v-if="item.type == 'quote'"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
              ></quote-widget>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="dataPage.route == 'contact'">
      <div id="main-contact">
        <div class="d-flex position-relative" id="titre">
          <h1>CONTACTEZ-NOUS</h1>
        </div>
        <div id="article">
          <div
            
            class="content-contact d-flex flex-column flex-lg-row  justify-content-left align-items-left mt-4 rowWidget"
          >
            <div class="col-lg-6 col-12" style="margin-top:100px">
              <div class="flex center flex-center mt-0 mb-4 text-left text-center form-send">
                  <feather-icon class="m-0"  icon='CheckCircleIcon' svgClasses='widthCheck'   />
                  <h4 class="mb-5 c-w">Pour prendre rendez-vous, merci de nous contacter exclusivement par téléphone.</h4>
                  <div class="docteurs row">
                    <div class="infos col-6 c-w mb-4">
                      <p><b>Dr Clémentine DECRETTE</b></p>
                      <p><a href="tel:0235025583" class="phone c-w" style="font-size:1.25rem">02 35 02 55 83</a></p>
                      <!-- <p>&gt;&gt; <a href="/docteur-clementine-decrette" class="">voir la fiche</a> &lt;&lt;</p> -->
                    </div>
                    <div class="infos col-6 c-w mb-4">
                      <p><b>Dr Thibault GANCEL</b></p>
                      <p><a href="tel:0235590412" class="phone c-w" style="font-size:1.25rem">02 35 59 04 12</a></p>
                      <!-- <p>&gt;&gt; <a href="/docteur-thibault-gancel" class="">voir la fiche</a> &lt;&lt;</p> -->
                    </div>
                    <div class="infos col-6 c-w mb-4">
                      <p><b>Dr Antoine GODDEFROY</b></p>
                      <p><a href="tel:0235712185" class="phone c-w" style="font-size:1.25rem">02 35 71 21 85</a></p>
                      <!-- <p>&gt;&gt; <a href="/docteur-antoine-goddefroy" class="">voir la fiche</a> &lt;&lt;</p> -->
                    </div>
                    <div class="infos col-6 c-w mb-4">
                      <p><b>Dr Edouard SOUBRANE</b></p>
                      <p><a href="tel:0235345102" class="phone c-w" style="font-size:1.25rem">02 35 34 51 02</a></p>
                      <!-- <p>&gt;&gt; <a href="/docteur-edouard-soubrane" class="">voir la fiche</a> &lt;&lt;</p> -->
                    </div>
                    <div class="infos col-6 c-w mb-4">
                      <p><b>Dr Alix LACOMBLEZ</b></p>
                      <p><a href="tel:0235025583" class="phone c-w" style="font-size:1.25rem">02 35 02 55 83 / 02 35 59 04 12</a></p>
                      <!-- <p>&gt;&gt;&gt;<a href="/docteur-alix-lacomblez" class="">voir la fiche</a>&lt;&lt;&lt;</p> -->
                    </div>
                    <div class="infos col-6 c-w mb-4">
                      <p><b>Dr Paul PEIGNON</b></p>
                      <p><a href="tel:0235345102" class="phone c-w" style="font-size:1.25rem">02 35 34 51 02</a></p>
                      <!-- <p>&gt;&gt; <a href="/docteur-marie-delaume" class="">voir la fiche</a> &lt;&lt;</p> -->
                    </div>
                    <div class="infos col-6 c-w mb-4">
                      <p><b>Dr Thomas GUILLEMETTE</b></p>
                      <p><a href="tel:0235345102" class="phone c-w" style="font-size:1.25rem">02 35 71 21 85</a></p>
                      <!-- <p>&gt;&gt; <a href="/docteur-marie-delaume" class="">voir la fiche</a> &lt;&lt;</p> -->
                    </div>
                  </div>
              </div>
            </div>
            <!--
            <div v-if="formContact.send" class="col-lg-6 col-12" style="margin-top:100px">
              <div class="flex center flex-center mt-4 mb-4 text-white text-center form-send">
                  <feather-icon class="m-0"  icon='CheckCircleIcon' svgClasses='widthCheck'   />
                  <h3 class="mt-2 mb-4">Merci</h3>
                  <p >    
                      Votre email a été correctément envoyé<br>
                      Nous vous répondrons dans les meilleurs délais
                  </p>
              </div>
            </div>
            <div v-else class="col-lg-6 col-12" id="contact">
              <div class="row">
                <div class="fancy-label name col-12 col-lg-6">
                  <input :class="errors.has('firstname') ? 'error' : ''" type="text" id="nom" name="firstname" v-validate="'required|alpha'" v-model="formContact.dataForm.firstname"  data-vv-validate-on="blur" />
                  <label for="nom">Votre Prénom</label>
                  <span class="text-danger text-sm text-error" v-show="errors.has('firstname')">{{ errors.first('firstname') }}</span>
                </div>

                <div class="fancy-label name col-12 col-lg-6">
                  <input :class="errors.has('lastname') ? 'error' : ''" type="text" id="prenom" name="lastname" v-validate="'required|alpha'" v-model="formContact.dataForm.lastname"  data-vv-validate-on="blur" />
                  <label for="prenom">Votre Nom</label>
                  <span class="text-danger text-sm text-error" v-show="errors.has('lastname')">{{ errors.first('lastname') }}</span>
                </div>

                <div class="fancy-label name col-12 col-lg-6">
                  <input :class="errors.has('phone') ? 'error' : ''" type="text" id="email" name="phone" v-validate="'required'" v-model="formContact.dataForm.phone" data-vv-validate-on="blur" />
                  <label for="email">Votre Téléphone</label>
                  <span class="text-danger text-sm text-error" v-show="errors.has('phone')">{{ errors.first('phone') }}</span>
                </div>
                <div class="fancy-label name col-12 col-lg-6">
                  <input :class="errors.has('email') ? 'error' : ''" type="text" id="email" name="email" v-validate="'required'" v-model="formContact.dataForm.email" data-vv-validate-on="blur" />
                  <label for="email">Votre Adresse E-mail</label>
                  <span class="text-danger text-sm text-error" v-show="errors.has('email')">{{ errors.first('email') }}</span>
                </div>
                <hr>
                <div class="fancy-label name col-12">
                  <select id="praticien" name="praticien"  class="form-control" v-model="formContact.dataForm.details[0].details[0].value" >
                      <option value="Tous les praticiens">Tous les praticiens</option>
                      <option value="Dr Clémentine DECRETTE">Dr Clémentine DECRETTE</option>
                      <option value="Dr Thibault GANCEL">Dr Thibault GANCEL</option>
                      <option value="Dr Antoine GODDEFROY">Dr Antoine GODDEFROY</option>
                      <option value="Dr Edouard SOUBRANE">Dr Edouard SOUBRANE</option>
                      <option value="Dr Marie DELAUME">Dr Marie DELAUME</option>
                      <option value="Dr Alix LACOMBLEZ">Dr Alix LACOMBLEZ</option>
                  </select>
                  <label for="praticien">Quel praticien souhaitez-vous joindre ?</label>
                </div>

                <div class="fancy-label name col-12">
                  <select id="objet" name="objet" class="form-control" v-model="formContact.dataForm.details[1].details[0].value">
                      <option value="Une demande de RDV">Une demande de RDV</option>
                      <option value="Une demande administrative">Une demande administrative</option>
                      <option value="Autre">Autre</option>
                  </select>
                  <label for="objet">Quel est l'objet de votre message ?</label>
                </div>

                <div class="fancy-label message name col-12 mb-2">
                  <textarea :class="errors.has('message') ? 'error' : ''"  v-validate="'required'" row="5" type="text" id="message" name="message" v-model="formContact.dataForm.details[1].details[1].value" data-vv-validate-on="blur"></textarea>
                  <label for="message">Votre message</label>
                  <span class="text-danger text-sm text-error" v-show="errors.has('message')">{{ errors.first('message') }}</span>
                </div>

                <div class="col-12 col-lg-6">
                    <vue-recaptcha ref="recaptcha" @verify="onVerify" sitekey="6Ldc4TwaAAAAAGQzSYruyBJ-zsoeP89j1uJjdamz">
                    </vue-recaptcha>
                </div>
                <div class="col-12 col-lg-6 mb-4">
                  <button id="button-contact" @click.prevent="submitForm">Envoyer mon message</button>
                </div>
              </div>
            </div>-->

            <div class="col-lg-6 col-12">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d750.3238715048234!2d1.1149476128527995!3d49.47087923013478!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e0dc4ff83b4c27%3A0x9e77674fb485fd2!2s362%20Rue%20de%20la%20R%C3%A9publique%2C%2076230%20Bois-Guillaume!5e0!3m2!1sfr!2sfr!4v1606487345628!5m2!1sfr!2sfr"
                width="100%"
                height="500"
                frameborder="0"
                allowfullscreen=""
                aria-hidden="false"
                tabindex="0"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
        <div id="main-contenu" class="pb-4">
        <div class="d-flex  position-relative" id="titre" v-if="typePage !== '1'">
            <h1>{{dataPage.title}}</h1>
        </div>

        <div
              class="item noEditMode d-flex flex-column flex-lg-row justify-content-start align-items-center c-w"
              v-for="(item, index) in layout"
              :key="index"
              id="article"
            >
              <row-widget
                v-if="item.type == 'row'"
                :layout="layout"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
                class="mb-2"
              ></row-widget>
              <col-widget
                v-if="item.type == 'col'"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
              ></col-widget>
              <text-widget
                v-if="item.type == 'text'"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
                :themeColors="themeColors"
              ></text-widget>
              <text-area-widget
                v-if="item.type == 'content'"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
              ></text-area-widget>
              <image-widget
                v-if="item.type == 'image'"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
              ></image-widget>
              <alert-widget
                v-if="item.type == 'alert'"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
                :color="item.color"
              >
              </alert-widget>
              <button-widget
                v-if="item.type == 'button'"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
              >
              </button-widget>
              <link-widget
                v-if="item.type == 'link'"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
              >
              </link-widget>
              <title-widget
                v-if="item.type == 'title'"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
              ></title-widget>
              <quote-widget
                v-if="item.type == 'quote'"
                :preview="preview"
                :contenteditable="contenteditable"
                :item="item"
                :itemIndex="index"
              ></quote-widget>
            </div>

    </div>
    </div>

    <!-- <div v-if="typePage == '1'">
      <div id="main-contact" class="pt-0 pt-0">
        <div class="d-flex position-relative" id="titre">
          <h1>Contacter le Docteur</h1>
        </div>

     

        <div
          id="article"
          class="content-contact d-flex flex-column flex-lg-row  justify-content-left align-items-left mt-4"
        >
          <div v-if="formContact.send" class="content-contact d-flex flex-column flex-lg-row  justify-content-left align-items-start mt-4 rowWidget" style="margin-top:100px; margin-bottom:40px">
            <div class="col-lg-12 col-12 text-white text-center form-send">
                <feather-icon class="m-0"  icon='CheckCircleIcon' svgClasses='widthCheck'   />
                <h3 class="mt-2 mb-4">Merci</h3>
                <p >    
                    Votre email a été correctément envoyé<br>
                    Nous vous répondrons dans les meilleurs délais
                </p>
            </div>
          </div>
          <div v-else class="content-contact d-flex flex-column flex-lg-row justify-content-left align-items-start mt-4 rowWidget" id="contact">
            <div class="col-lg-6 col-12">
              <div class="row">
                <div class="fancy-label name col-12 col-lg-6">
                  <input :class="errors.has('firstname') ? 'error' : ''" type="text" id="nom" name="firstname" v-validate="'required|alpha'" v-model="formContact.dataForm.firstname"  data-vv-validate-on="blur" />
                  <label for="nom">Votre Prénom</label>
                  <span class="text-danger text-sm text-error" v-show="errors.has('firstname')">{{ errors.first('firstname') }}</span>
                </div>
                <div class="fancy-label name col-12 col-lg-6">
                  <input :class="errors.has('lastname') ? 'error' : ''" type="text" id="prenom" name="lastname" v-validate="'required|alpha'" v-model="formContact.dataForm.lastname"  data-vv-validate-on="blur" />
                  <label for="prenom">Votre Nom</label>
                  <span class="text-danger text-sm text-error" v-show="errors.has('lastname')">{{ errors.first('lastname') }}</span>
                </div>
                <div class="fancy-label name col-12 col-lg-6">
                  <input :class="errors.has('phone') ? 'error' : ''" type="text" id="email" name="phone" v-validate="'required'" v-model="formContact.dataForm.phone" data-vv-validate-on="blur" />
                  <label for="email">Votre Téléphone</label>
                  <span class="text-danger text-sm text-error" v-show="errors.has('phone')">{{ errors.first('phone') }}</span>
                </div>
                <div class="fancy-label name col-12 col-lg-6">
                  <input :class="errors.has('email') ? 'error' : ''" type="text" id="email" name="email" v-validate="'required'" v-model="formContact.dataForm.email" data-vv-validate-on="blur" />
                  <label for="email">Votre Adresse E-mail</label>
                  <span class="text-danger text-sm text-error" v-show="errors.has('email')">{{ errors.first('email') }}</span>
                </div>
                <div class="fancy-label name col-12">
                  <select id="objet" name="objet" class="form-control" v-model="formContact.dataForm.details[1].details[0].value">
                      <option value="Une demande de RDV">Une demande de RDV</option>
                      <option value="Une demande administrative">Une demande administrative</option>
                      <option value="Autre">Autre</option>
                  </select>
                  <label for="objet">Quel est l'objet de votre message ?</label>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-12">
              <div class="row">

                <div class="fancy-label message name col-12 mb-2">
                  <textarea :class="errors.has('message') ? 'error' : ''"  v-validate="'required'" row="5" type="text" id="message" name="message" v-model="formContact.dataForm.details[1].details[1].value" data-vv-validate-on="blur"></textarea>
                  <label for="message">Votre message</label>
                  <span class="text-danger text-sm text-error" v-show="errors.has('message')">{{ errors.first('message') }}</span>
                  <input type="hidden" name="nom-praticien" v-model="formContact.dataForm.details[0].details[0].value">

                </div>

                <div class="col-12 col-lg-6">
                    <vue-recaptcha ref="recaptcha" @verify="onVerify" sitekey="6Ldc4TwaAAAAAGQzSYruyBJ-zsoeP89j1uJjdamz">
                    </vue-recaptcha>
                </div>
                <div class="col-12 col-lg-6 mb-4">
                  <button id="button-contact" @click.prevent="submitForm">Envoyer mon message</button>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div> -->
    <v-style>
      /* Use CustomerVar with example : {{ customizableVar1 }}
      Set Background Image with example :
      background-image:url('\{\{require('@/html/elements/after-page-title-0f555d.svg')}}')
      !important; */
    </v-style>
      <div class="parallax-abstract" v-if="dataPage.route == 'accueil'"></div>
      <div class="parallax-abstract-top" v-else></div>
      <div class="container">
        <!-- GENERE CI-DESSOUS LE PAGE BUILDER EN APERCU SEUL -->
        <div
          class="item noEditMode"
          v-for="(item, index) in layout"
          :key="index"
        >
          <col-widget
            v-if="item.type == 'col'"
            :preview="preview"
            :contenteditable="contenteditable"
            :item="item"
            :itemIndex="index"
          ></col-widget>
          <text-widget
            v-if="item.type == 'text'"
            :preview="preview"
            :contenteditable="contenteditable"
            :item="item"
            :itemIndex="index"
            :themeColors="themeColors"
          ></text-widget>
          <text-area-widget
            v-if="item.type == 'content'"
            :preview="preview"
            :contenteditable="contenteditable"
            :item="item"
            :itemIndex="index"
          ></text-area-widget>
          <image-widget
            v-if="item.type == 'image'"
            :preview="preview"
            :contenteditable="contenteditable"
            :item="item"
            :itemIndex="index"
          ></image-widget>
          <alert-widget
            v-if="item.type == 'alert'"
            :preview="preview"
            :contenteditable="contenteditable"
            :item="item"
            :itemIndex="index"
            :color="item.color"
          >
          </alert-widget>
          <button-widget
            v-if="item.type == 'button'"
            :preview="preview"
            :contenteditable="contenteditable"
            :item="item"
            :itemIndex="index"
          >
          </button-widget>
          <link-widget
            v-if="item.type == 'link'"
            :preview="preview"
            :contenteditable="contenteditable"
            :item="item"
            :itemIndex="index"
          >
          </link-widget>
          <title-widget
            v-if="item.type == 'title'"
            :preview="preview"
            :contenteditable="contenteditable"
            :item="item"
            :itemIndex="index"
          ></title-widget>
          <quote-widget
            v-if="item.type == 'quote'"
            :preview="preview"
            :contenteditable="contenteditable"
            :item="item"
            :itemIndex="index"
          ></quote-widget>
        </div>
      </div>
    
    <div class="bg-footer-page"  v-if="dataPage.route == 'contact' || dataPage.route == 'le-cabinet'" style="background-image:url('./elements/equipe-cbgr.png');background-size: auto 100%; background-position: bottom center; background-repeat: no-repeat; "></div>

  </div>

   
</template>
<style>
/* PAGE ACCUEIL */
.carousel-caption {
    right: 0px;
    left: 0px;
    bottom: 0px;
    padding: 0px;
}



/* PAGE CONTENU */

#article {
    margin-top: 0px;
    /* padding: 0 45px; */
}

#main-contenu {
    padding-top: 100px;
    padding-bottom: 80px;
}

#main-contenu .col-right p {
    font-size: 1.6rem;
}


/* PAGE CONTACT */

#main-contact {
  padding-top: 150px;
  padding-bottom: 60px;
}

/* FORMULAIRE */

#contact {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.fancy-label {
  position: relative;
  margin-bottom: 30px;
}
.fancy-label label {
  position: absolute;
  top: 11px;
  left: 20px;
  padding: 0 5px;
  transition: top 0.5s, font-size 0.3s;
}
.fancy-label input,
.fancy-label textarea {
  height: 45px;
  padding: 0 12px;
}
.message textarea {
  height: 200px;
}
.name input, textarea {
  width: 100%;
}
.name input#nom, .name input#prenom, .name input#email, .name input#telephone{
    padding-left: 15px;
}
textarea#message{
    padding-top: 5px;
}
.fancy-label.name input {
  padding: 0;
}
.name label {
  margin-left: 9px;
}
.fancy-label input:hover + label,
.fancy-label textarea:hover + label,
.name label:hover,
.fancy-label input:focus + label,
.fancy-label textarea:focus + label,
.fancy-label input:valid + label,
.fancy-label textarea:valid + label {
  top: -9px;
  font-size: 12px;
}
label {
  color: #fff;
  background: #154059;
}
input,
textarea {
  color: #fff;
      border: 1px solid #ccc;
  background: #154059;
  width: 100%;
  outline: 0;
}

input.error,
textarea.error {
  border:1px solid red
}
.text-error {
    color: #dc3545!important;
    font-size: 12px;
    padding-left: 20px;
    font-style:italic
}

/* CARTES DOCTEUR*/

#pres-docteurs {
  margin: 100px 0 80px 0;
}

.cards-doc img {
  width: calc(100% - 70px);
  margin-bottom: 20px;
  border-radius: 1000px;
}
.cards-doc a {
  line-height: 0;
}
#main-contact .content-contact iframe {
  border: 0px solid #ccc;
}

@media (max-width: 840px) {
  #main-contact {
    padding-top: 40px;
    padding-bottom: 80px;
  }
  #titre h1 {
    padding-left: 1rem;
  }
  .name label {
    margin-left: 0;
  }
}

#titre h1 {
  width: 100vw;
  z-index: 5;
  padding-bottom: 15px;
  bottom: 0px;
  color: #fff;
  font-size: 1.8rem;
  padding-left: 45px;
  position: relative;
  width: fit-content;
}

#titre h1:before {
  content: "";
  display: block;
  position: absolute;
  height: 2px;
  width: calc(100% + 62px);
  bottom: 0px;
  left: -20px;
  background-color: #ccc;
}
#titre h1:after {
  content: "";
  display: block;
  position: absolute;
  height: 2px;
  width: 60px;
  bottom: 27px;
  background-color: #ccc;
  transform: rotate(65deg);
  left: calc(100% - 1px);
  border-radius: 10px;
}
</style>
<script>
// FIREBASE
import "firebase/auth";
const firebase = require("firebase");
require("firebase/firestore");
require("firebase/auth");
var db = firebase.firestore();
import { firebaseConfig } from "@/firebase/firebaseConfig";
import { setSubCollection, setSub2Collection } from "@/../script/global";
import axios from "axios";
import dayjs from "dayjs";

import EspHeader from "@/layouts/Header.vue"
// CONFIG
import { themeConfig, irisConfig } from "@/../siteConfig.js";

// SPECIFIC TO PAGEBUILDER
import RowWidget from "../editor/RowWidget";
import ColWidget from "../editor/ColWidget";
import TextWidget from "../editor/TextWidget";
import TextAreaWidget from "../editor/TextAreaWidget";
import ImageWidget from "../editor/ImageWidget";
import AlertWidget from "../editor/alertWidget";
import ButtonWidget from "../editor/ButtonWidget";
import LinkWidget from "../editor/LinkWidget";
import TitleWidget from "../editor/TitleWidget";
import QuoteWidget from "../editor/QuoteWidget";
import { GridLayout, GridItem } from "vue-grid-layout";

// SPECIFIC FOR CONTACT
import VueRecaptcha from "vue-recaptcha";
import { Validator } from "vee-validate";
const dict = {
  custom: {
    lastname: {
      required: "Veuillez saisir votre nom",
    },
    firstname: {
      required: "Veuillez saisir votre prénom",
    },
    phone: {
      required: "Veuillez saisir votre numéro de téléphone",
    },
    email: {
      required: "Veuillez saisir votre adresse email",
    },
    objet: {
      required: "Veuillez saisir l'objet de votre message",
    },
    message: {
      required: "Veuillez saisir votre message",
    },
  },
};
Validator.localize("fr", dict);

export default {
  components: {
    RowWidget,
    ColWidget,
    TextWidget,
    TextAreaWidget,
    ImageWidget,
    AlertWidget,
    ButtonWidget,
    LinkWidget,
    TitleWidget,
    QuoteWidget,
    VueRecaptcha,
    EspHeader,
  },
  name: "page-view",
  props: {
    dataPage: {
      type: Object,
    },
    dataIris: {
      type: Object,
    },
  },
  data() {
    return {
      contenteditable: false,
      preview: true,
      irisConfig: irisConfig,

      // DATA objet pour instancier la collection Leads sur la Dashboard
      formContact:{
        dataForm:{
            lastname: '',
            firstname: '',
            phone: '',
            email: '',
            details:[
                {
                    icon:"",
                    label:"Information destinataire",
                    details:[
                        {
                            label:"Nom du praticien",
                            value:""
                        },
                        {
                            label:"E-mail du praticien",
                            value:""
                        }
                    ]
                },
                {
                    icon:"",
                    label:"Détails du message",
                    details:[
                        {
                            label:"Objet",
                            value:""
                        },
                        {
                            label:"Message",
                            value:""
                        }
                    ]
                }
            ],
            status:"Non traité",
            addDate:new Date()
        },
        robot: false,
        send:false
      },
      // DATA  pour générer la map OpenStreet
      map: null,
      tileLayer: null,
      mapMarker: [
        {
          id: 0,
          name:
            "<b>CBGR</b><br>362 Rue de la république<br>76230 Bois-Guillaume",
          type: "marker",
          coords: [49.475604, 1.129772],
        },
      ],
    };
  },
  computed: {
    dataPageInfos: function () {
      if (this.dataPage) {
        return this.dataPage || "";
      } else {
        return "";
      }
    },
    layout: function () {
      if (this.dataPage.gridLayout.length > 0) {
        return this.dataPage.gridLayout || "";
      } else {
        return "";
      }
    },
    color1: function () {
      if (this.dataIris.customizableVar[0].value) {
        return this.dataIris.customizableVar[0].value;
      } else {
        return "0f555d";
      }
    },
    color2: function () {
      if (this.dataIris.customizableVar[1].value) {
        return this.dataIris.customizableVar[1].value;
      } else {
        return "0f555d";
      }
    },
    customizableVar1: function () {
      if (this.dataIris.customizableVar[0].value) {
        return this.dataIris.customizableVar[0].value;
      } else {
        return "0f555d";
      }
    },
    typePage: function () {
      if (this.dataPageInfos.customizableVar[3].value) {
        return this.dataPageInfos.customizableVar[3].value.value;
      } else {
        return "0";
      }
    },
    urlPictureHeader: function () {
      if (this.dataPage.urlPictureHeader) {
        return this.dataPage.urlPictureHeader;
      } else {
        return ""; // Ajouter  pour définir une image par défaut :  require('@/html/elements/bg-header.jpg')
      }
    },
  },
  mounted() {
    // On verifi si la page est la page contact afin d'initialiser la map
    this.checkPageContact();
  },
  watch: {
    dataPage(newData, old) {
      // On regarde si la route a changée
      //console.log("Ancienne route : ", old, "Nouvelle route : ", newData);
      this.checkPageContact();
    },
  },
  methods: {
    checkPageContact() {
      if (this.dataPage.id == "QsKFEBPCq9ujZckvVv9S") {
        setTimeout(() => {
          this.initMap();
          this.initMarkers();
        }, 500);
      } else {
        if (this.map) {
          this.map.remove();
        }
      }
    },

    // Methodes pour la page contact Form et Map
    submitForm() {
      if (this.formContact.robot) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.formContact.send = true;
          if(this.typePage==1){
            this.formContact.dataForm.details[0].details[0].value=this.dataPage.customizableVar[5].value;
            this.formContact.dataForm.details[0].details[1].value=this.dataPage.customizableVar[4].value;
          }
          this.sendMail()
          setSub2Collection(
            "customers",
            this.irisConfig.customers,
            "sites",
            this.irisConfig.sites,
            "leads",
            this.formContact.dataForm
          );
        } else {
        }
      });
      }
    },
    onVerify: function (response) {
      if (response) this.formContact.robot = true;
    },
     sendMail() {
      // ENVOI DU MAIL
      var data = new FormData();

      if(this.typePage==1){
        this.formContact.dataForm.details[0].details[0].value=this.dataPage.customizableVar[5].value;
        this.formContact.dataForm.details[0].details[1].value=this.dataPage.customizableVar[4].value;
        data.set("to", this.dataPage.customizableVar[4].value);
      }else{
      
        if(this.formContact.dataForm.details[0].details[0].value=="Dr Clémentine DECRETTE"){
          data.set("to", 'clementine.decrette@cbgr.fr');
          this.formContact.dataForm.details[0].details[1].value="clementine.decrette@cbgr.fr";
        }else if(this.formContact.dataForm.details[0].details[0].value=="Dr Thibault GANCEL"){
          data.set("to", 'thibault.gancel@cbgr.fr');
          this.formContact.dataForm.details[0].details[1].value="thibault.gancel@cbgr.fr";
        }else if(this.formContact.dataForm.details[0].details[0].value=="Dr Antoine GODDEFROY"){
          data.set("to", 'antoine.goddefroy@cbgr.fr');
          this.formContact.dataForm.details[0].details[1].value="antoine.goddefroy@cbgr.fr";
        }else if(this.formContact.dataForm.details[0].details[0].value=="Dr Edouard SOUBRANE"){
          data.set("to", 'edouard.soubrane@cbgr.fr');
          this.formContact.dataForm.details[0].details[1].value="edouard.soubrane@cbgr.fr";
        }else if(this.formContact.dataForm.details[0].details[0].value=="Dr Marie DELAUME"){
          data.set("to", 'marie.delaume@cbgr.fr');
          this.formContact.dataForm.details[0].details[1].value="marie.delaume@cbgr.fr";
        }else if(this.formContact.dataForm.details[0].details[0].value=="Dr Alix LACOMBLEZ"){
          data.set("to", 'alix.lacomblez@cbgr.fr');
          this.formContact.dataForm.details[0].details[1].value="alix.lacomblez@cbgr.fr";
        }else{
          data.set("to", 'contact@cbgr.fr');
          this.formContact.dataForm.details[0].details[1].value="contact@cbgr.fr";
        }
      }

      // data.set("to", 'mathieu.werquin@devinfluence.fr');
      data.set("cci", "contact@devinfluence.fr");
     
      data.append("customer", 'CBGR');
      data.append("website", 'www.cbgr.fr');
      data.append("lastname", this.formContact.dataForm.lastname);
      data.append("firstname", this.formContact.dataForm.firstname);
      data.append("phone", this.formContact.dataForm.phone);
      data.append("email", this.formContact.dataForm.email);
       data.append(
        "details",
        JSON.stringify(this.formContact.dataForm.details)
      );
      data.append("date", dayjs().format("DD/MM/YYYY"));
      data.append("hours", dayjs().format("HH"));
      data.append("minutes", dayjs().format("mm"));
      axios({
        method: "post",
        url: "https://app.orisis.fr/api-email.php?request=emailFromWebSiteForm",
        data: data,
      })
        .then(function(reponse) {
          //On traite la suite une fois la réponse obtenue
          //console.log(reponse);
        })
        .catch(function(erreur) {
          //On traite ici les erreurs éventuellement survenues
          console.error(erreur);
        });
    },
    initMarkers() {
      this.mapMarker.forEach((mapMarkerData) => {
        var marker = L.marker(mapMarkerData.coords).addTo(this.map);
        marker.bindPopup(mapMarkerData.name).openPopup();
      });
    },
    initMap() {
      this.map = L.map("mapid").setView([49.475604, 1.129772], 16);
      this.tileLayer = L.tileLayer(
        "https://cartodb-basemaps-{s}.global.ssl.fastly.net/rastertiles/voyager/{z}/{x}/{y}.png",
        {
          maxZoom: 18,
          attribution:
            '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attribution">CARTO</a>',
        }
      );
      this.tileLayer.addTo(this.map);
    },
  },
};
</script>
